import React from "react"
import {
  UncontrolledDropdown,
  Dropdown,
  DropdownMenu,
  DropdownItem,
  DropdownToggle,
  Media,
  Badge
} from "reactstrap"
import PerfectScrollbar from "react-perfect-scrollbar"
import * as Icon from "react-feather"
import ReactCountryFlag from "react-country-flag"
import { connect } from "react-redux"
import { FormattedMessage } from "react-intl"
import {
  buscarCarrinho,
  setItens,
  updateItem,
  removeItem
} from "../../../redux/actions/checkout/index"
import { changeMode } from "../../../redux/actions/customizer/index"
import { history } from "../../../history"
import { IntlContext } from "../../../utility/context/Internationalization"
import noimage from '../../../assets/img/backgrounds/no_image.jpg'

const handleNavigation = (e, path) => {
  e.preventDefault()
  history.push(path)
}

const UserDropdown = props => {
  return (
    <DropdownMenu right>
      <DropdownItem tag="a" href="#" onClick={e => handleNavigation(e, "/faq")}>
        <Icon.Phone size={14} className="mr-50" />
        <span className="align-middle"><FormattedMessage id="Contact"/></span>
      </DropdownItem>
    </DropdownMenu>
  )
}

class NavbarUser extends React.PureComponent {
  state = {
    langDropdown: false,
    suggestions: []
  }

  componentWillMount(){
    this.props.buscarCarrinho();
  }

  removerItem = item => {
    if(localStorage.checkout != undefined && localStorage.checkout != []) {
      var checkout = JSON.parse(localStorage.checkout);
      var i = checkout.findIndex(i => i.id+''+i.unid == item.CodProduto+''+item.Unidade);
      if(i > -1)
        checkout.splice(i, 1);
      
      localStorage.checkout = JSON.stringify(checkout);
      this.props.buscarCarrinho();
    }
  }

  handleLangDropdown = () =>
    this.setState({ langDropdown: !this.state.langDropdown })

  render() {
    const renderCartItems = this.props.checkout.itens.map((item, i) => {
      return (
        <div className="cart-item" key={i}>
          <Media
            className="p-0"
            onClick={() => window.location.href = "/produto?CodProduto="+item.CodProduto+'&Unidade='+item.Unidade}
          >
            <Media className="text-center pr-0 mr-1" left>
            {
              item.image != null ? <img
              style={{ maxHeight: 70 }}
              className={`${
                item.imgClass
                  ? item.imgClass + " cart-item-img"
                  : "cart-item-img"
              }`}
              src={item.image}
              alt={'Item carrinho'}
            /> : <img
              style={{ maxHeight: 70 }}
              className={`${
                item.imgClass
                  ? item.imgClass + " cart-item-img"
                  : "cart-item-img"
              }`}
              src={noimage}
              alt={'Item carrinho'}
            />
            }
            </Media>
            <Media className="overflow-hidden pr-1 py-1 pl-0" body>
              <span className="item-title text-truncate text-bold-500 d-block mb-50">
                {item.Desceq}
              </span>
              {/* <span className="item-desc font-small-2 text-truncate d-block">
                {item.desc}
              </span> */}
              <div className="d-flex justify-content-between align-items-center mt-1">
                <span className="align-middle d-block">{item.Quantidade} x {item.Valor.toLocaleString("pt-BR", { style: "currency" , currency:"BRL"})}</span>
                <Icon.X
                  className="danger"
                  size={15}
                  onClick={e => {
                    e.stopPropagation()
                    this.removerItem(item)
                  }}
                />
              </div>
            </Media>
          </Media>
        </div>
      )
    })

    return (
      <ul className="nav navbar-nav navbar-nav-user float-right">
        {/* <li className="dropdown-notification nav-item dropdown">
          <a className="nav-link position-relative" style={{ fontWeight: '700', marginTop: 10 }} onClick={() => window.location = '/panel'}>Admin</a>
        </li> */}
        <UncontrolledDropdown
          tag="li"
          className="dropdown-notification nav-item"
        >
          <DropdownToggle tag="a" className="nav-link position-relative">
            <Icon.ShoppingCart size={21} />
            {this.props.checkout.itens.length > 0 ? (
              <Badge pill color="primary" className="badge-up">
                {this.props.checkout.itens.length}
              </Badge>
            ) : null}
          </DropdownToggle>
          <DropdownMenu
            tag="ul"
            right
            className={`dropdown-menu-media dropdown-cart ${
              this.props.checkout.itens.length === 0 ? "empty-cart" : ""
            }`}
          >
            <li
              className={`dropdown-menu-header ${
                this.props.checkout.itens.length === 0 ? "d-none" : "d-block"
              }`}
            >
              <div className="dropdown-header m-0">
                <h3 className="white">
                  {this.props.checkout.itens.length} <FormattedMessage id="Items"/>
                </h3>
                <span className="notification-title"><FormattedMessage id="InYourCart"/></span>
              </div>
            </li>
            <PerfectScrollbar
              className="media-list overflow-hidden position-relative"
              options={{
                wheelPropagation: false
              }}
            >
              {renderCartItems}
            </PerfectScrollbar>
            <li
              className={`dropdown-menu-footer border-top ${
                this.props.checkout.itens.length === 0 ? "d-none" : "d-block"
              }`}
            >
              <div
                className="dropdown-item p-1 text-center text-primary"
                onClick={() => window.location.href = "/checkout"}
              >
                <Icon.ShoppingCart size={15} />
                <span className="align-middle text-bold-600 ml-50">
                  Ver carrinho
                </span>
              </div>
            </li>
            <li
              className={`empty-cart ${
                this.props.checkout.itens.length > 0 ? "d-none" : "d-block"
              } p-2`}
            >
             <FormattedMessage id="EmptyCart"/>
            </li>
          </DropdownMenu>
        </UncontrolledDropdown>
        <li style={{ marginTop: 20, marginLeft: 5 }}>
          <h6 style={{ color: 'red', fontWeight: '700' }}>{this.props.checkout.subtotal.toLocaleString("pt-BR", { style: "currency" , currency:"BRL"})}</h6>
        </li>
        <div style={{ width: '20px' }}></div>
      </ul>
    )
  }
}

const mapStateToProps = state => {
  return {
    checkout: state.checkout,
    customizer: state.customizer
  }
}

export default connect(mapStateToProps, {
  setItens,
  removeItem,
  updateItem,
  buscarCarrinho,
  changeMode
})(NavbarUser)